const storage = {};

export const getItem = (key) => {
  if ( localStorage && localStorage.getItem ) {
    return localStorage.getItem(key);
  } else if ( storage ) {
    return storage[key];
  }
};

export const setItem = (key, value) => {
  if ( localStorage && localStorage.setItem ) {
    return localStorage.setItem(key, value);
  } else {
    return storage[key] = value;
  }
};

export const removeItem = (key) => {
  if ( localStorage && localStorage.removeItem ) {
    return localStorage.removeItem(key);
  } else {
    return delete(storage[key]);
  }
};



// WEBPACK FOOTER //
// ./src/module/LocalStorage.js